import * as z from "zod";

function isAtLeast18(birthdateStr: string): boolean {
  const birthDate = new Date(birthdateStr);
  const today = new Date();

  const age = today.getFullYear() - birthDate.getFullYear();
  const hasHadBirthdayThisYear =
    today.getMonth() > birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

  return age > 18 || (age === 18 && hasHadBirthdayThisYear);
}

export const RegisterFormValidation = z.object({
  email: z.string().email("Email inválido"),
  name: z.string().min(1, "Nombre requerido"),
  surname: z.string().min(1, "Apellidos requeridos"),
  birthday: z
    .string()
    .min(1, "Fecha de nacimiento requerida")
    .refine(isAtLeast18, { message: "Debes tener al menos 18 años" }),
    phone: z.string()
    .regex(/^[6789]\d{8}$/, {
      message: "Teléfono no válido",
    }),
  photo: z.string().optional(),
  acceptTerms: z.literal(true, {
    errorMap: () => ({ message: "Debes aceptar los términos y condiciones" }),
  }),
});

export type IRegisterFormValidation = z.infer<typeof RegisterFormValidation>;
